import React, { useState, memo, useEffect } from "react";
import axios from 'axios';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export const NewUnacceptanceResult = memo((props) => {
  const { hospital_id, corporations, addAcceptanceResult, type_val } = props;
  const initialUnaptResultState = {
    corporation_id: '',
    notes: '',
  }
  const [currentUnaptResult, setCurrentUnaptResult] = useState(initialUnaptResultState);

  const notify = (type, message) => {
    if (type === "success") {
      toast.success(message, {
        hideProgressBar: true
      });
    } else {
      toast.error(message, {
        hideProgressBar: true
      });
    }
  }

  const onChangeData = (e) => {
    setCurrentUnaptResult({
      ...currentUnaptResult,
      [e.target.name]: e.target.value,
    })
  };

  const onClinicUnaptResultSubmit = () => {
    if (!currentUnaptResult.corporation_id || !currentUnaptResult.notes) {
      alert("※全項目が必須選択・入力です。");
      return
    }

    var data = {
      acceptance_result: {
        hospital_id: hospital_id,
        corporation_id: parseInt(currentUnaptResult.corporation_id, 10),
        type: type_val,
        notes: currentUnaptResult.notes,
      }
    }

    // axios csrfToken
    const csrfToken = document.querySelector('[name=csrf-token]').content
    axios.defaults.headers.common['X-CSRF-Token'] = csrfToken

    axios.post(`/api/v1/acceptance_results`, data)
    .then(resp => {
      console.log("成功");
      console.log(resp.data);
      addAcceptanceResult(resp.data);
      notify("success", "AcceptanceResult successfully created!");
      setCurrentUnaptResult(initialUnaptResultState);
    })
    .catch(e => {
      console.log(e.response);
      // alert(JSON.parse(e.request.responseText).errors);
      notify("error", "AcceptanceResult create Error!");
    })
  }

  return (
    <>
      <div className="row">
        <div className="col-10">
          <div className="input-group mb-3">
            <span className="input-group-text" id="title-basic-enabled">企業</span>
            <select name="corporation_id" id="basic-corporations" className="form-select" value={currentUnaptResult.corporation_id} onChange={onChangeData}>
              <option value="">必須選択</option>
              {corporations.map(item => 
                <option key={item.id} value={item.id}>{item.name}</option>
              )}
            </select>
            <textarea type="text" name="notes" className="form-control w-25" id="basic-notes" cols="30" rows="1" placeholder="理由内容を入力※必須" value={currentUnaptResult.notes} onChange={onChangeData}></textarea>
          </div>
        </div>
        <div className="col-2">
          <button className="btn btn-primary" onClick={onClinicUnaptResultSubmit} disabled={(!currentUnaptResult.corporation_id || !currentUnaptResult.notes)}>
            <i className="far fa-plus-square" /> 追加
          </button>
        </div>
      </div>
    </>
  );
});